"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceholderFlightTab = void 0;
const react_1 = __importDefault(require("react"));
const react_content_loader_1 = __importDefault(require("react-content-loader"));
const PlaceholderFlightTab = () => (react_1.default.createElement(react_content_loader_1.default, { viewBox: '0 0 380 500' },
    react_1.default.createElement("rect", { x: '0', y: '0', width: '70', height: '40' }),
    react_1.default.createElement("rect", { x: '0', y: '50', width: '70', height: '35' }),
    react_1.default.createElement("rect", { x: '75', y: '50', width: '70', height: '35' }),
    react_1.default.createElement("rect", { x: '150', y: '50', width: '70', height: '35' }),
    react_1.default.createElement("rect", { x: '225', y: '50', width: '70', height: '35' }),
    react_1.default.createElement("rect", { x: '300', y: '50', width: '70', height: '35' }),
    react_1.default.createElement("rect", { x: '0', y: '88', width: '370', height: '70' })));
exports.PlaceholderFlightTab = PlaceholderFlightTab;
//# sourceMappingURL=index.js.map